import { useQuery } from '@tanstack/react-query';

import { CompanyResource } from '@/types/resources';
import { api } from '@/utils/api';

const useCompaniesOptions = () => {
  return useQuery(
    ['companies'],
    () => api.get<never, CompanyResource[]>('/v1/companies'),
    {
      select: (data) =>
        data.map((item) => ({
          value: item.id,
          label: item.name,
          hide_from_dropdowns: item.hide_from_dropdowns,
        })),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
  );
};

export default useCompaniesOptions;
